var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioActiveAnimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5ZM12.75 18.9603C16.2633 18.5861 19 15.6126 19 12C19 11.5858 18.6642 11.25 18.25 11.25C17.8358 11.25 17.5 11.5858 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12C6.5 11.5858 6.16421 11.25 5.75 11.25C5.33579 11.25 5 11.5858 5 12C5 15.6126 7.73668 18.5861 11.25 18.9603V21.5H9.00001C8.58579 21.5 8.25 21.8358 8.25 22.25C8.25 22.6642 8.58579 23 9.00001 23L9.00392 23H11.25H12.75H15C15.4142 23 15.75 22.6642 15.75 22.25C15.75 21.8358 15.4142 21.5 15 21.5H12.75V18.9603Z",
    fill: "white",
    fillOpacity: 0.62
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4649 14H8.53516C9.22678 15.1956 10.5195 16 12 16C13.4806 16 14.7733 15.1956 15.4649 14Z",
    fill: "#23D959"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M15.4649 14H8.53516C9.22678 15.1956 10.5195 16 12 16C13.4806 16 14.7733 15.1956 15.4649 14Z;M16 12H8C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z;M16 10H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V10Z;M16 7H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V7Z;M8.12602 4C8.04375 4.31962 8 4.6547 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 4.6547 15.9562 4.31962 15.874 4H8.12602Z;M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5Z;M8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12V5Z;M8.12602 4C8.04375 4.31962 8 4.6547 8 5V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V5C16 4.6547 15.9562 4.31962 15.874 4H8.12602Z;M16 7H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V7Z;M16 10H8V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V10Z;M16 12H8C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z;M15.4649 14H8.53516C9.22678 15.1956 10.5195 16 12 16C13.4806 16 14.7733 15.1956 15.4649 14Z",
    calcMode: "linear",
    dur: "0.8s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioActiveAnimated);
export default __webpack_public_path__ + "static/media/icon-audio-active-animated.36c67e2ce5a29b9c5d3d6f13c2650643.svg";
export { ForwardRef as ReactComponent };